module.exports = __webpack_public_path__ + "static/media/fallout.f88a6141.jpg";